import React from 'react';
import cn from 'classnames';
import CfButton from './CfButton/CfButton';
import holdIcon from '../../../images/cf-hold.svg';
import Icon from '../../Icon/Icon';

class Slide extends React.Component {
    render() {
        const {
            id,
            cf_ht,
            cf_at,
            name_ht,
            name_at,
            chance_ht,
            chance_at,
            logo_ht,
            logo_at,
            score,
        } = this.props;

        return (
            <a className='header-slide' href={`${app.mainUrl}/#/esports/${id}`} target='_blank'>
                <CfButton className={cn({ hold: !cf_ht })}>
                    {cf_ht || <Icon glyph={holdIcon} />}
                </CfButton>

                <span className='header-slide__team'>{name_ht}</span>

                <span className='header-slide__chance'>{chance_ht}%</span>

                <img className='header-slide__logo' src={`${app.mainUrl}/img/logo/${logo_ht}`} />

                <span
                    className={cn('header-slide__scale', chance_ht < 50 ? 'negative' : 'positive')}
                >
                    <img src={`${app.assetsPath}/images/scale.png`} />
                    <span style={{ height: chance_ht + '%' }} />
                </span>

                <span className='header-slide__score'> {score}</span>

                <span
                    className={cn('header-slide__scale', chance_at < 50 ? 'negative' : 'positive')}
                >
                    <img src={`${app.assetsPath}/images/scale.png`} />
                    <span style={{ height: chance_at + '%' }} />
                </span>

                <img className='header-slide__logo' src={`${app.mainUrl}/img/logo/${logo_at}`} />

                <span className='header-slide__chance'>{chance_at}%</span>

                <span className='header-slide__team header-slide__team--away'>{name_at}</span>

                <CfButton className={cn({ hold: !cf_at })}>
                    {cf_at || <Icon glyph={holdIcon} />}
                </CfButton>
            </a>
        );
    }
}

export default Slide;



// WEBPACK FOOTER //
// ./components/HeaderSlider/Slide/Slide.jsx